module.exports = __webpack_public_path__ + "img/gongyinglian.787a45b4.png";